<template>
    <div>
        <sys-select-base
            :model.sync="selected"
            :items="items"
            :loading="loading"
            :label="label"
            :error="error"
            :errors="errors"
            :clearable="clearable"
            :dense="dense"
            :disabled="disabled || !dayOfWeekId || !companyId"
            :return-object="true"
            @change="$emit('change', $event)"
            :hideDetails="hideDetails"
            :class="classe"
            :classe="classe"
        />
    </div>
</template>

<script>

import { mapActions } from 'vuex'

export default {
    name: 'SysSelectIntegrationHour',
    data: () => ({
        items: [],
        loading: false,
        selected: null,
        suppressClear: false,
    }),
    created() {
        this.getItems();
    },
    props: {
        error: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Array,
        },
        label: {
            type: String,
            default: ''
        },
        clearable: {
            type: Boolean,
            default: true
        },
        model: {

        },
        dense: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        hideDetails: {
            type: [Boolean, String],
            default: false
        },
        classe: {

        },
        dayOfWeekId: {

        },
        companyId: {

        },
        integrationShiftId: {

        },
        hydrating: {
            type: Boolean,
            default: false
        },
    },
    watch: {
        selected(val, oldVal){
            // O Vuetify pode zerar a selecao momentaneamente quando a lista
            // de items e substituida (getItems refazendo a busca), mesmo que
            // o valor atual continue valido. Ignora essa limpeza espuria
            // enquanto uma busca esta em andamento - quem decide o valor
            // final e o proprio getItems() ao re-sincronizar com o model.
            if (val == null && oldVal != null && this.suppressClear) {
                this.selected = oldVal;
                return;
            }

            this.$emit('update:model', val);
            this.$emit('select', val);
        },

        model(val){
            this.selected = val;
        },

        dayOfWeekId(){
            if (this.hydrating) return;
            this.getItems();
        },

        companyId(){
            if (this.hydrating) return;
            this.getItems();
        },

        integrationShiftId(){
            if (this.hydrating) return;
            this.getItems();
        },

        hydrating(val){
            // Refaz a busca quando o pai termina de hidratar, pra buscar
            // com os filtros finais (evita refetch prematuro que faz o
            // Vuetify perder a selecao atual em meio a hidratacao).
            if (!val) this.getItems();
        },
    },
    methods: {
        ...mapActions('integration', ['ActionIndexIntegrationHours']),

        async getItems() {

            if (!this.dayOfWeekId || !this.companyId) {
                this.items = [];
                return;
            }

            this.loading = true;
            this.suppressClear = true;

            let payload = {
                find_columns: {
                    day_of_week_id: this.dayOfWeekId,
                    company_id: this.companyId,
                },
                with: 'hour,integrationShift',
            }

            if(this.integrationShiftId){
                payload.find_columns.integration_shift_id = this.integrationShiftId;
            }

            await this.ActionIndexIntegrationHours(payload)
                    .then((res) => {

                        this.items = (res.data || []).map((row) => {

                            const hourStart = row.hour ? row.hour.start : '--:--';
                            const hourEnd = row.hour ? row.hour.end : '--:--';

                            return {
                                ...row,
                                name: `${hourStart} às ${hourEnd}`,
                            };
                        });

                        this.selected = this.model;

                    })
                    .finally(() => {
                        this.loading = false;
                        setTimeout(() => { this.suppressClear = false; }, 100);
                    })
        },
    },

}
</script>
